import { useDraggable } from '@dnd-kit/core';
import { IconGripVertical } from '@tabler/icons-react';
import type { RefObject } from 'react';
import { useEffect, useState } from 'react';
import { TOUR_ID } from '../tours/DraftEditorTour';
import ToolbarActions from './ToolbarActions';

export default function FloatingToolbar({
  xPosition,
  onMount,
  aiActionButton,
}: {
  containerRef: RefObject<HTMLDivElement | null>;
  xPosition: number;
  onMount?: (toolbarElement: HTMLElement | null) => void;
  aiActionButton?: () => void;
}) {
  const [ready, setReady] = useState(false);
  const { attributes, listeners, setNodeRef, transform, node, isDragging } = useDraggable({
    id: 'draggable-toolbar',
  });

  // Apply position from parent and add transform delta during dragging
  const translateX = isDragging && transform ? xPosition + transform.x : xPosition;

  useEffect(() => {
    onMount?.(node.current);

    // Delay the animation to prevent flickering on mount.
    // 3000 is just a magical number. The better way to do is to listen to the VM state.
    setTimeout(() => setReady(true), 3000);
  }, []);

  return ready ?
      <div
        id={TOUR_ID.FLOATING_TOOLBAR}
        ref={setNodeRef}
        className={`absolute top-0 flex flex-row items-center justify-center rounded-sm bg-[var(--mantine-color-gray-1)] dark:bg-[var(--mantine-color-dark-8)] ${ready ? 'opacity-100' : 'opacity-0'} shadow-md transition-opacity ease-in`}
        style={{ left: `${translateX}px` }}
      >
        <div
          {...listeners}
          {...attributes}
          className={`p-1 ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
        >
          <IconGripVertical
            size={16}
            color="gray"
          />
        </div>
        <ToolbarActions
          aiActionButton={aiActionButton}
          isWeb
        />
      </div>
    : null;
}
